import { lazyNamed } from 'src/utils/lazyNamed';

export const Products = {
  List: lazyNamed(() => import('./containers/ProductsList'), 'ProductsList'),
  Edit: lazyNamed(() => import('./containers/ProductEdit'), 'ProductForm'),
};
